import { render, staticRenderFns } from "./RcaItem.vue?vue&type=template&id=b7f068ea&scoped=true"
import script from "./RcaItem.vue?vue&type=script&lang=js"
export * from "./RcaItem.vue?vue&type=script&lang=js"
import style0 from "./RcaItem.vue?vue&type=style&index=0&id=b7f068ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f068ea",
  null
  
)

export default component.exports